import Card from 'components/Layout/Card';
import React, { useEffect, useState } from 'react';
import ConferenceCard from './Websites/ConferenceCard';
import { eventLogoPath, icons } from 'utils/constants';
import { Row, Col } from 'react-bootstrap';
import SeachInput from 'components/form/SeachInput';
import { useDispatch } from 'react-redux';
import { fetchNewAllEvents } from 'store/slices';
import {
  generatePreSignedUrl,
  getUserType,
  objectToFormData,
} from 'utils/helpers';
import ReactPaginate from 'react-paginate';
import './Websites.scss';
import { useParams } from 'react-router-dom';
import AllProfiles from './AllProfiles';
const Websites = ({ tabType }) => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const [searchText, setSearchText] = useState('');
  const [searchPayload, setSearchPayload] = useState({ event_name: '' });
  const [filterData, setFilterData] = useState({
    total: 0,
    offset: 0,
    limit: 12,
  });
  const [timer, setTimer] = useState(null);
  const [tableList, setTableList] = useState([]);
  const [newPaginateActivePage, setNewPaginateActivePage] = useState(0);
  const [formattedEvents, setFormattedEvents] = useState([]);

  const memberType = getUserType();

  const handleSearch = (e) => {
    let value = e.target.value;
    setSearchText(value);

    clearTimeout(timer);
    const newTimer = setTimeout(() => {
      const updatedSearchPayload = { event_name: value };
      setSearchPayload(updatedSearchPayload);
      const updatedFilterData = {
        ...filterData,
        offset: 0,
        ...updatedSearchPayload,
      };
      setFilterData(updatedFilterData);
      setIsLoading(true);
      getEvents(updatedFilterData);
    }, 800);
    setTimer(newTimer);
  };

  const getEvents = async (obj) => {
    let formData = objectToFormData(obj);
    const response = await dispatch(fetchNewAllEvents(formData));
    setTableList(response?.data?.events || []);
    setFilterData((prev) => ({
      ...prev,
      total: response?.data?.result_count || 0,
    }));
    setIsLoading(false);
  };

  useEffect(() => {
    getEvents({ ...filterData, ...searchPayload });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlePageChange = (selectedPage) => {
    const newOffset = selectedPage.selected * filterData.limit;
    const updatedFilterData = { ...filterData, offset: newOffset };
    setNewPaginateActivePage(selectedPage.selected);
    getEvents(updatedFilterData);
  };

  const totalPage = Math.ceil(filterData.total / filterData.limit);

  // const formattedEvents = tableList.map((event) => ({
  //   logo: event?.event_logo ? generatePreSignedUrl(event.event_logo,eventLogoPath) : icons.logo,
  //   title: event.event_name,
  //   date: `${event.start_date} - ${event.end_date}`,
  //   location: `${event.city_name}, ${event.country_name}`,
  //   moreDetailsLink: event.id,
  // }));

  const formatEventDate = (startDate, endDate) => {
    const start = new Date(startDate);
    const end = new Date(endDate);

    const dayOptions = { day: 'numeric' };
    const monthOptions = { month: 'short' };
    const yearOptions = { year: 'numeric' };

    const startDay = new Intl.DateTimeFormat('en-US', dayOptions).format(start);
    const endDay = new Intl.DateTimeFormat('en-US', dayOptions).format(end);
    const month = new Intl.DateTimeFormat('en-US', monthOptions).format(end);
    const year = new Intl.DateTimeFormat('en-US', yearOptions).format(end);

    if (start.toDateString() === end.toDateString()) {
      return `${startDay}-${month}-${year}`;
    }

    return `${startDay} & ${endDay}-${month}-${year}`;
  };

  useEffect(() => {
    const fetchEventLogos = async () => {
      if (tableList.length === 0) {
        setFormattedEvents([]);
        return;
      }

      const eventsWithUrls = await Promise.all(
        tableList.map(async (event) => {
          const logoUrl = event?.event_logo
            ? await generatePreSignedUrl(event.event_logo, eventLogoPath)
            : icons.logo;

          return {
            logo: logoUrl,
            title: event.event_name,
            date: formatEventDate(event.start_date, event.end_date),
            location: `${event.city_name}, ${event.country_name}`,
            moreDetailsLink: `/${memberType}/event-management/event-details/${event.id}/conference-details`,
            event_short_name: event.event_short_name,
          };
        })
      );

      setFormattedEvents(eventsWithUrls);
    };

    fetchEventLogos();
  }, [tableList]);

  const [selectEventShortName, setSelectEventShortName] = useState('');
  return (
    <>
      {!selectEventShortName ? (
        <Card className="cps-20 cpe-20 cpb-20">
          <div className="d-flex justify-content-between">
            <div className="table-title cmb-20 cpt-28">
              Conference Websites ({filterData?.total})
            </div>
            <div style={{ width: '220px' }} className="cmb-20 cpt-28">
              <SeachInput
                placeholder="Search"
                value={searchText}
                onChange={handleSearch}
              />
            </div>
          </div>

          <div className="d-flex justify-content-center">
            <Row className="g-3 justify-content-center w-100">
              {formattedEvents.map((conference, index) => (
                <Col key={index} xs={12} sm={8} md={6} lg={4} xl={3}>
                  <ConferenceCard
                    {...conference}
                    setSelectEventShortName={setSelectEventShortName}
                  />
                </Col>
              ))}
            </Row>
          </div>

          {totalPage > 1 && (
            <div className="d-flex justify-content-center react-pagination cmt-50">
              <ReactPaginate
                pageCount={totalPage}
                breakLabel="..."
                previousLabel="Prev"
                nextLabel="Next"
                renderOnZeroPageCount={null}
                containerClassName="pagination"
                previousLinkClassName="page-link"
                nextLinkClassName="page-link"
                activeClassName="active"
                disabledLinkClassName="disable-page-link"
                onPageChange={handlePageChange}
                pageRangeDisplayed={5}
                marginPagesDisplayed={2}
                forcePage={newPaginateActivePage}
              />
            </div>
          )}
        </Card>
      ) : (
        <>
          <Card className="cps-20 cpe-20 cpb-20">
            <div className="cpt-10">
              <img
                src={icons.leftArrow}
                alt="back"
                className="h-21 pointer"
                onClick={() => setSelectEventShortName('')}
              />
            </div>
          </Card>
          <AllProfiles
            tabType="0"
            selectEventShortName={selectEventShortName}
          />
        </>
      )}
    </>
  );
};

export default Websites;
